<template>
    <body>
        <div class="wrapper">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand" href="#">{{appShortName}}</a>
            </nav>
            <div style="min-height: 621px;">
                <div class="container" style="word-break: break-all;">
                    <div class="bg-white" style="margin-left:10px; margin-right: 10px;">
                        <div style="clear: both">
                            <br>
                            <br>
                            <div class="image-row">
                                <div class="image-column">
                                    <img src="../../assets/topleft.png">
                                </div>
                                <div class="image-column">

                                </div>
                            </div>
                            <div class="logotipo">
                                <!--    <div class="logo">
                                    <img src="../../assets/logoassinatura.png">
                                </div>
                                <div class="medalha">
                                    <img src="../../assets/medalha.png">
                                </div> -->
                            </div>
                            <div class="interna centralizada">
                                <h2 style="text-align:center">A empresa AR MBD SOLUÇÕES DIGITAIS na qualidade de
                                    certificadora privada, certifica
                                    que o documento</h2>

                                <span style="font-size:x-large">
                                    {{file.arquivo_nome}}.{{file.arquivo_extensao}}
                                </span>
                                <br>
                                Documento número / Código para Verificação {{file.id}}
                                <br>
                                <img :src="file.qrCode" />
                                <br>
                                <h2>foi assinado eletronicamente nos termos do artigo 10 § 1º da MP 2.200-2/2001 de 24
                                    de Agosto de 2001 e nos termos do artigo 4 da lei número 14.063, de 23 de setembro
                                    de 2020</h2>
                                <br>
                            </div>
                        </div>
                        <div class="interna">
                            <h4 style="text-align: center">Aceites do Termo de Uso, Política de Privacidade e
                                Especificações
                                Técnicas</h4>
                            <br>
                            <template v-for="(termo, i) in file.termos">
                                <div v-if="termo.assinado_em" style="clear:both; text-align: center" :key="i">
                                    <div class="assinatura-linha">
                                        <div class="assinatura-nome">
                                            {{termo.usuario}}
                                        </div>
                                        <div class="assinatura-data">
                                            {{formatDateExtenso(termo.assinado_em)}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <br>
                            <br>
                            <span style="font-size:x-large">
                                Assinaturas
                            </span>
                            <br>
                            <br>
                            <br>
                            <template v-for="assinatura in file.assinaturas">
                                <div style="clear:both" :key="assinatura.id">
                                    <div style="float:left">
                                        <img v-if="assinatura.assinado" src="../../assets/ok.png"
                                            style="width: 25px; height: 25px;">
                                        <img v-else src="../../assets/not-ok.png" style="width: 25px; height: 25px;">
                                    </div>
                                    <div style="float:left">
                                        <div style="margin-top: 7px;">
                                            {{assinatura.assinatura_nome}}<br>
                                        </div>
                                        <div style="color:darkgray">
                                            {{getTipoAssinatura(assinatura.assinatura_tipo, assinatura.assinado)}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                        </div>
                        <div style="clear: both" class="interna">
                            <br>
                            <hr style="">
                            <br>
                            <span style="font-size:x-large">
                                Histórico de eventos
                            </span>
                            <br>
                            <br>
                            <template v-for="evento in file.eventos">
                                <section :key="evento.id">
                                    <span width="150px" valign="top">
                                        <b>{{formatDate(evento.created_at)}}</b>
                                    </span>
                                    <span style="margin-left:5%;margin-top:-40%" v-html="evento.evento_publico"></span>
                                    <br>
                                    <br>
                                </section>
                            </template>

                        </div>
                        <div style="clear:both;" class="interna">
                            <br>
                            <br>
                            <hr style="">
                            <p style="font-size:small">
                                Hash do documento original (SHA256):
                                {{file.arquivo_hash}}
                            </p>
                            <p style="font-size:small">
                                Esta página com o histórico de eventos foi criada única e exclusivamente para o
                                documento de
                                HASH acima.<br>
                                Datas e horários em GMT -03:00 Brasilia<br>
                                Atualizado em {{formatDateExtenso(file.updated_at)}}<br>
                                A {{appShortName}} assina e certifica este documento.
                            </p>
                        </div>

                        <div class="footer-interna">
                            <div class="image-row">
                                <div class="image-column">

                                </div>

                                <div class="image-column">
                                    <img src="../../assets/bottomright.png">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-footer clearfix" style="margin-left:0px">
                <div class="float-right hidden-xs">
                    <b>{{appName}} versão 2.0</b>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
    export default {
        data() {
            return {
                file: {
                    assinaturas: [],
                    eventos: []
                }
            }
        },
        beforeMount() {
            if (!this.$route.query.arquivo) {
                this.$route.push('/consulta-publica');
            }
            this.$store.dispatch('getVerificacaoPublica', this.$route.query.arquivo).then(response => {
                console.log(response);
                this.file = response;
            });
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        }
    }
</script>


<style scoped>
    html {
        height: 100%;
    }

    body {
        height: 100%;
    }

    section {
        height: 100%;
    }


    .content-header {
        margin-bottom: 50px;
    }

    .row {
        display: flex;
        justify-content: center;
    }

    .content-wrapper,
    .main-footer {
        margin-left: 0px !important;
    }

    .wrapper-validar {
        margin-top: 50px;
    }

    .image-row {
        margin: 0 auto;
        text-align: center;
    }

    .image-row ::after {
        content: "";
        clear: both;
        display: table;
    }

    .image-column {
        display: inline-block;
        margin: 0 auto;
        /*float: left;*/
        width: 48%;
        /*padding: 5px;*/
    }

    .image-column>img {
        width: 80%;
    }

    .logotipo {
        width: 80%;
        margin: -50px auto 0 auto;
    }

    .logotipo>div {
        display: inline-block;
        margin: 0 auto;
        width: 49%;
        text-align: center;
    }

    .logotipo .medalha>img {
        width: 35%;
        margin-top: 15px
    }

    .logotipo .logo>img {
        width: 50%;
        margin-top: 15px;
        margin-left: 50px;
    }

    .centralizada {
        text-align: center;
    }

    .interna {
        width: 80%;
        margin: 0 auto;
    }

    .interna h2 {
        font-size: 12pt;
        text-align: justify;
        font-weight: bold;
        font-family: Calibri;
    }

    .footer-interna {
        margin-bottom: 50px;
    }

    .assinatura-linha {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-evenly;
    }

    .assinatura-linha>.assinatura-nome {
        text-align: left;
        min-width: 30%;
    }

    .assinatura-linha>.assinatura-data {
        text-align: right;
        text-transform: uppercase;
        min-width: 25%;
    }

    body {
        background-image: url("../../assets/email-pattern.png");
    }

    @media print {
        body {
            background-image: none;
        }
    }
</style>